<template>
  <div class="">
    <feature-input-text-area v-if="featureType === 'text'" :product="product"
                             :feature-product="featureProduct"/>


    <component :is="listFeatureComponent" v-if="'list' == featureType"
               :product="product"
               :feature-product="featureProduct"
    />

    <feature-input-list
        v-if="['radio','switch','list-with-number-value','list-with-text-value'].indexOf(featureType) > -1"
        :product="product"
        :feature-product="featureProduct"/>
    <feature-input-checkbox :product="product" :feature-product="featureProduct"
                            v-if="['checkbox','checkbox-step'].indexOf(featureType) > -1"/>

    <feature-input-date :product="product" :feature-product="featureProduct" v-if="featureType === 'date'"/>

    <feature-input-number :product="product" :feature-product="featureProduct" v-if="featureType === 'number'"/>

    <component :is="stepListFeatureComponent" :product="product" :feature-product="featureProduct"
               v-if="featureType === 'list-step'"/>

  </div>
</template>

<script>
import FeatureInputTextArea from "./FeatureInputTextArea.vue";
import FeatureInputList from "../FeatureInput/FeatureInputList.vue";
import FeatureInputCheckbox from "../FeatureInput/FeatureInputCheckbox.vue";
import FeatureInputDate from "../FeatureInput/FeatureInputDate.vue";
import FeatureInputNumber from "../FeatureInput/FeatureInputNumber.vue";
import FeatureInputListStep from "./FeatureInputListStep.vue";
import FeatureInputListStep2 from "./FeatureInputListStep2.vue";
import FeatureInputList2 from "../FeatureInput/FeatureInputList2.vue";

export default {
  name: "FeatureInputManager",
  components: {
    FeatureInputListStep,
    FeatureInputNumber,
    FeatureInputDate,
    FeatureInputCheckbox,
    FeatureInputList,
    FeatureInputTextArea,
    FeatureInputListStep2,
    FeatureInputList2
  },
  props: {
    featureProduct: {},
    product: {},
    stepListFeatureComponent: {
      default: '',
    },
    listFeatureComponent: {
      default: '',
    }
  },
  computed: {
    isCheckbox() {
      return Array.isArray(this.featureProduct)
    },
    featureType() {
      return this.isCheckbox ? 'checkbox' : this.featureProduct.feature.type
    },
  }
}
</script>

<style scoped>

</style>